import { useAppContext } from "../../../../lib/appContext";
import { SliderDesktop } from "./Desktop";
import { SliderMobile } from "./Mobile";

export const useSliderComponent = () => {
  const { isMobile } = useAppContext();
  return isMobile ? SliderMobile : SliderDesktop;
};
